module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@my-records",
      "gclick": function () {},
      "link": require('./img/checkstatus/my-records.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j5",
      "gclick": function () {},
      "link": require('./img/checkstatus/j5.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j7",
      "gclick": function () {},
      "link": require('./img/checkstatus/j7.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j9",
      "gclick": function () {},
      "link": require('./img/checkstatus/j9.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-rule",
      "gclick": function () {},
      "link": require('./img/checkstatus/btn-rule.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-nike",
      "gclick": function () {},
      "link": require('./img/checkstatus/btn-nike.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-nike",
      "gclick": function () {},
      "link": require('./img/checkstatus/btn-nike.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@rules-text",
      "gclick": function () {},
      "link": require('./img/checkstatus/rules-text.png')
    },
    on: {
      "final-position": function (ref) {
        var pos = ref.pos;
        var params = ref.params;

        _vm.tryMaximiseScroller({
          pos: pos,
          params: params,
          extra: 45
        })
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j5",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j5 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j7",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j7 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j9",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j9 = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-743c8dff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Status/Status.vue
// module id = 602
// module chunks = 0